import { useLocation, useNavigate } from 'react-router-dom';
import { useDippyStore } from '@/stores/dippy-store';
import { useDippySettings } from '@/hooks/useDippySettings';
import { useDippyAlerts } from '@/hooks/useDippyAlerts';
import DippyCharacter from './DippyCharacter';
import DippySpeechBubble from './DippySpeechBubble';
import DippyPanel from './DippyPanel';

export default function Dippy() {
  const location = useLocation();
  const navigate = useNavigate();
  const { config, loading } = useDippySettings();

  const {
    isPanelOpen,
    expression,
    currentBubble,
    badgeCount,
    togglePanel,
    openPanel,
    dismissBubble,
    setTab,
  } = useDippyStore();

  // Run proactive alerts engine
  useDippyAlerts(config);

  // Show on agent and dropshipping pages
  const isAgentPage = location.pathname.startsWith('/admin/agent');
  const isDropshipPage = location.pathname.startsWith('/admin/supplier');
  if (!isAgentPage && !isDropshipPage) return null;

  // Respect enabled setting
  if (loading || !config.enabled) return null;

  const handleBubbleClick = () => {
    dismissBubble();
    if (currentBubble?.action?.href) {
      navigate(currentBubble.action.href);
    } else {
      openPanel();
      setTab('status');
    }
  };

  const showBubble = config.alert_style === 'speech_bubble' && !isPanelOpen;

  return (
    <div
      className="fixed bottom-4 left-4 z-40"
      data-testid="dippy-container"
    >
      {/* Speech bubble */}
      {showBubble && (
        <DippySpeechBubble
          bubble={currentBubble}
          onDismiss={dismissBubble}
          onClick={handleBubbleClick}
        />
      )}

      {/* Panel */}
      <DippyPanel
        isOpen={isPanelOpen}
        dippyName={config.name}
        avatar={config.avatar}
      />

      {/* Character */}
      <DippyCharacter
        avatar={config.avatar}
        expression={expression}
        badgeCount={config.alert_style === 'bounce_badge' ? badgeCount : 0}
        onClick={togglePanel}
      />
    </div>
  );
}
